import { Component, OnInit } from "@angular/core";
import { SeoServiceService } from "src/app/services/seo-service.service";

@Component({
  selector: "app-refund-policy",
  templateUrl: "./refund-policy.component.html",
  styleUrls: ["./refund-policy.component.scss"],
})
export class RefundPolicyComponent implements OnInit {
  constructor(private seoService: SeoServiceService) {}

  ngOnInit(): void {
    this.seoService.createLinkForCanonicalURL();
  }

  data = [
    {
      name1: "Refund Policy : ",
      name2: " Pre-recorded Training",
      details: [
        "You can cancel your order if a request is made within 24 hours of placing the order. The full amount will be refunded. Your refund will be processed through the same mode of payment through which you have purchased the course.",
      ],
    },
    {
      name1: "Refund Policy : Digital Personalised / Group Training",
      name2: "  and Teacher at Doorstep",
      details: [
        "You can cancel your order if a request is made within 24 hours of placing the order. The full amount will be refunded.",
        "Online personalised and Group training is refundable maximum to the extent of the remaining sessions the user has not consumed.",
      ],
    },
    {
      name1: "Refund Policy : ",
      name2: " B2B (Schools) ",
      details: [
        "Please contact your sales representative or contact us at info@virsaindia.in.",
      ],
    },
    {
      name1: "Refund Policy : ",
      name2: " E - commerce",
      details: [
        "For the return of product(s) damaged at the time of delivery, the shipping charges shall be borne by the Company. However, for the return of the product(s) for any other reasons, it shall be the responsibility of the User to arrange for the return of such cancelled product(s), and such User shall bear the shipping charges.",
        "We request that you not accept any product package that seems to be tampered with, opened or damaged at the delivery time. The products must be returned in the same condition as the Company’s delivery. Any products returned showing signs of any use or damage in any manner shall not be accepted for return.",
      ],
    },
  ];

  moreDetails = [
    "No Refund will be provided after 15 days from delivery.",

    "The product should be returned along with the original invoices and in original packing.",

    "Refunds shall be made to the bank account within 10 working days of receipt of products.",

    "Your refund will be processed through the same mode of payment through which you have purchased the course.",

    "A Refund Request will be deemed valid only if it is made through an email to info@virsaindia.in with your registered email ID.",
  ];
}
